async function castError(res: Response): Promise<any> {
  if (res.status >= 500) throw Error('Server side problem');
  const json = await res.json().catch(() => null);
  if (res.ok && json) return json;
  else if (res.status == 401) throw Error(`Access denied: ${json}`);
  else throw Error(`Undefined error: ${json}`);
}

export { castError };
